import React from 'react';
import PropTypes from 'prop-types';
import { CalloutBox, CALLOUTBOX_THEMES } from 'src/components/Elements/CalloutBox';

const AddSkuV2DisclaimerText = ({ sku, className }) => {
  const disclaimerText = sku && sku.getIn(['skuMessagings', 'disclaimer']);
  if (!disclaimerText) return null;
  return (
    <CalloutBox
      theme={CALLOUTBOX_THEMES.CRITICAL}
      header="Disclaimer"
      text={disclaimerText}
      className={className}
    />
  );
};

AddSkuV2DisclaimerText.propTypes = {
  sku: PropTypes.object,
  className: PropTypes.string,
};

export default AddSkuV2DisclaimerText;
